<template>
  <div class="tag-wrap">
    <div class="tag-list">
      <h3>{{ $t("adminCompanies.list") }}</h3>
      <div v-for="(cmp, i) in cmps" :key="i" class="single-tag">
        <span>{{ cmp.cmp_name }}</span>
        <span class="material-icons" @click="deleteCmp(cmp)"> close </span>
      </div>
    </div>
    <div class="modify-tag">
      <div class="add-tag">
        <h3>{{ $t("adminCompanies.createCmpTitle") }}</h3>
        <span>{{ $t("adminCompanies.cmpName") }}</span>
        <input type="text" v-model="cmp_name" @keydown.enter="createCmp" />
        <br />
        <span>{{ $t("adminCompanies.cmpLocation") }}</span>
        <input type="text" v-model="cmp_loc" @keydown.enter="createCmp" />
        <br />
        <span>{{ $t("adminCompanies.cmpUrl") }}</span>
        <input type="text" v-model="cmp_url" @keydown.enter="createCmp" />
        <br />
        <label for="cmpImg">{{ $t("adminCompanies.cmpImg") }}</label>
        <input id="cmpImg" type="file" @change="addFile" />
        <br />
        <button class="button-round" @click="createCmp">
          {{ $t("adminCompanies.createCmp") }}
        </button>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      cmps: [],
      cmp_name: "",
      cmp_loc: "",
      cmp_url: "",
      file: null,
      data: new FormData(),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.startLoading();
      let res;
      try {
        res = await api.getCompanies();
        console.log(res.data);
        this.cmps = res.data.result;

				this.cmp_name =  ""
				this.cmp_loc =  ""
				this.cmp_url =  ""
				this.file =  null;
				this.data =  new FormData()
				let input = document.querySelector('cmpImg')
				input.value = null
				
      } catch (e) {
        console.warn(e);
      }
      this.stopLoading();
    },
    async createCmp() {
      if (!this.cmp_name || !this.cmp_loc || !this.cmp_url || !this.file)
        return;
      try {
        this.data.append("cmp_name", this.cmp_name);
        this.data.append("cmp_location", this.cmp_loc);
        this.data.append("cmp_url", this.cmp_url);
        let res = await api.postCompany(this.data);
        console.log(res.data);
        this.openToast(this.$t("adminCompanies.createOk"));
        this.init();
      } catch (error) {
        console.warn(error);
        this.customError(this.$t("adminCompanies.fail"));
      }
    },
    addFile() {
      let f = document.querySelector("#cmpImg").files[0];
      console.log(f);
      this.file = f;
      this.data.append("cmp_image", f);
    },
    deleteCmp(cmp) {
      const confirmProp = {
        title: this.$t("adminCompanies.delete", { name: cmp.cmp_name }),
        okCallback: async () => {
          try {
            let res = await api.deleteCompany(cmp.cmp_id);
            console.log(res.data);
            this.openToast(this.$t("adminCompanies.deleteOk"));
            this.init();
          } catch (error) {
            console.warn(error);
            this.customError(this.$t("adminCompanies.fail"));
          }
        },
      };
      this.EventBus.$emit("confirm", confirmProp);
    },
  },
};
</script>

<style scoped lang='scss'>
.tag-wrap {
  padding: 40px 20px;
  display: flex;
}
.tag-list {
  width: 20%;
  .single-tag {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      opacity: 1;
      .material-icons {
        opacity: 1;
      }
    }
    .material-icons {
      transition: all 0.1s ease-in-out;
      opacity: 0;
      cursor: pointer;
    }
  }
}
.modify-tag {
  margin-left: 30px;
  width: 40%;
}
</style>